import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";

export const COPY_RECIPIENT_NOTICE_MODES = Object.freeze({
  BLAST: "blast",
  BULK: "bulk",
  CAMPAIGN: "campaign",
});

const NOTICE_TEXT = Object.freeze({
  [COPY_RECIPIENT_NOTICE_MODES.BULK]:
    "Each CC and BCC address will receive one proof copy when this bulk email is sent. " +
    "They will not receive a separate copy for each contact. For example, if you send a bulk " +
    "email to 100 contacts, each CC or BCC address will receive one proof copy, not 100 copies.",
  [COPY_RECIPIENT_NOTICE_MODES.BLAST]:
    "Each CC and BCC address will receive one proof copy when this blast email is sent. " +
    "They will not receive a separate copy for each team contact. For example, if you send a " +
    "blast email to 100 team contacts, each CC or BCC address will receive one proof copy, not " +
    "100 copies.",
  [COPY_RECIPIENT_NOTICE_MODES.CAMPAIGN]:
    "Warning: Each CC and BCC address will receive a copy every time this campaign step emails " +
    "a contact. For example, if this step emails 100 contacts, each CC or BCC address will " +
    "receive 100 emails.",
});

const CopyRecipientNotice = ({ mode }) => (
  <Alert variant="info" className="py-2 mb15">
    {NOTICE_TEXT[mode]}
  </Alert>
);

CopyRecipientNotice.propTypes = {
  mode: PropTypes.oneOf(Object.values(COPY_RECIPIENT_NOTICE_MODES)).isRequired,
};

export default CopyRecipientNotice;
